// extracted by mini-css-extract-plugin
module.exports = {"PublicFooter":"PublicFooter_PublicFooter__psayZ","main-links":"PublicFooter_main-links__jAMeB"};